// © Microsoft Corporation. All rights reserved.

import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { ContentActionsToolbarClassNames } from ".";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { toPx } from "@microsoft/fast-jss-utilities";

const toolbarMinDim = 40;
const iconHeight = 32;

/**
 * The ContentActionsToolbar styles
 * @type {ComponentStyles<ContentActionsToolbarClassNameContract, DesignSystem>}
 */
export const ContentActionsToolbarStyles: ComponentStyles<ContentActionsToolbarClassNames, DesignSystem> = (config: DesignSystem) => {
    return {
        contentActionsToolbar: {
            "background-color": "none"
        },
        contentActionsToolbar_vertical: {
            width: toPx(toolbarMinDim)
        },
        contentActionsToolbar_horizontal: {
            width: "auto"
        }
    };
};